import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { dismiss, hold, release, runNewestUndo, subscribe } from "../lib/toast";

function Item({ t }) {
  const on = useRef({ hover: false, focus: false });
  const set = (k, v) => {
    const was = on.current.hover || on.current.focus;
    on.current[k] = v;
    const now = on.current.hover || on.current.focus;
    if (now !== was) (now ? hold : release)(t.id);
  };
  return (
    <div className="toast" data-testid="toast" onMouseEnter={() => set("hover", true)} onMouseLeave={() => set("hover", false)}
      onFocus={() => set("focus", true)} onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) set("focus", false); }}>
      <span className="toast-text" data-testid="flash-message">{t.text}</span>
      {t.undo && <button className="toast-undo hit" onClick={() => { dismiss(t.id); t.undo(); }} data-testid="toast-undo">↺ Undo</button>}
      <button className="toast-x" aria-label="Dismiss" onClick={() => dismiss(t.id)} data-testid="toast-dismiss">×</button>
    </div>
  );
}

export function Toasts() {
  const [list, setList] = useState([]);
  useEffect(() => subscribe((l) => setList([...l])), []);
  useEffect(() => {
    const key = (e) => {
      if (e.key.toLowerCase() !== "z" || !(e.ctrlKey || e.metaKey) || e.shiftKey || e.altKey || e.repeat) return;
      const el = document.activeElement;
      if (el && (el.matches("input, textarea, select") || el.isContentEditable)) return;
      if (runNewestUndo()) e.preventDefault();
    };
    window.addEventListener("keydown", key);
    return () => window.removeEventListener("keydown", key);
  }, []);
  return createPortal(
    <div id="ck-toasts" className="toasts" role="status" aria-live="polite" aria-atomic="false" data-testid="toast-region">
      {list.map((t) => <Item key={t.id} t={t} />)}
    </div>, document.body);
}
